import createFetchClient from 'openapi-fetch';
import createClient from 'openapi-react-query';
import type { paths } from '../generated/apiTypes';
import type { paths as archivePaths } from '../generated/archiveApiTypes';
import { createApiStatusMiddleware } from './apiStatusMiddleware';
import { apiArchiveBaseUrl, apiBaseUrl } from './config';

export const fetchClient = createFetchClient<paths>({
  baseUrl: apiBaseUrl,
  querySerializer: {
    array: {
      style: 'form',
      explode: false,
    },
  },
});

fetchClient.use(createApiStatusMiddleware());

export type FetchClient = typeof fetchClient;

export const archiveFetchClient = createFetchClient<archivePaths>({
  baseUrl: apiArchiveBaseUrl,
  querySerializer: {
    array: {
      style: 'form',
      explode: false,
    },
  },
});
archiveFetchClient.use(createApiStatusMiddleware());
export type ArchiveFetchClient = typeof archiveFetchClient;

export const dataOrThrow = <TData, TResponse, TError>(apiResponse: {
  response: TResponse;
  data?: TData;
  error?: TError;
}): {
  data: TData;
  response: TResponse;
} => {
  if (apiResponse.data === undefined) {
    throw apiResponse.error ?? new Error('No data');
  }

  return {
    data: apiResponse.data,
    response: apiResponse.response,
  };
};

export const apiClient = createClient(fetchClient);
export type ApiClient = typeof apiClient;
